import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Grid } from "../../core/components/grid";
import { DatePicker } from "../../core/components/datePicker";
import { FlagContext, FlagEntity } from "./editFlag";
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { FieldInstance } from "../../core/components/field";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { BaseComponentProps, BaseField } from "../../core/components/baseComponentProps";
import { GridCustomToolBarButton } from "../../core/components/toolBar";
import React from "react";
export default class FlagAssignmentsGrid extends React.Component<FlagAssignmentsGridProps, FlagAssignmentsGridState>{
    private factory = ComponentHelper.createFactory();
    private buttons: Array<GridCustomToolBarButton> = [];
    constructor(props) {
        super(props)
        const monday = Helper.dates.getLastMonday(new Date());
        const sunday = Helper.dates.addDays(monday, 6);
        this.state = {
            gridData: [],
            from: monday,
            until: sunday
        }
        this.initApp();
    }

    private initApp = () => {
        if (this.props.entity.RecordRight.AddAssignments) {
            this.buttons = [
                {
                    autoEnabledOnRecordSelected: false,
                    caption: this.props.context.translations["WebCRM.Tasks.RecurringTaskHistory.CreateAssignments"],
                    enabled: true,
                    iconClass: "fal fa-calendar-alt",
                    id: "addAssignments"
                }
            ];
        }
        this.loadAssignments()
    }

    private loadAssignments = async () => {
        const result = await HTTPService.noBusyIndicator().post<JsonResultClass<any[]>>("PlanningBoardFlag/GetAssignmentsByFlagId", {
            FlagId: this.props.entity.Id,
            From: this.state.from,
            Until: this.state.until
        });
        if (result.Code == 0)
            this.setState({ gridData: result.Data })
        else
            NotificationHelper.showErrorMessage(result.Message)
    }


    private renderFromDatePicker = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.value = this.state.from;
        props.onChange = (_, value) => {
            if (Helper.isNullOrEmpty(Helper.dates.toString(value)))
                value = this.state.from;
            this.setState({ from: value }, this.loadAssignments)
        }
        return (
            <FieldInstance label={this.props.context.translations["Field.Beleg.dvon"]}>
                <DatePicker {...props} />
            </FieldInstance>
        );
    }

    private renderUntilDatePicker = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.value = this.state.until;
        props.onChange = (_, value) => {
            if (Helper.isNullOrEmpty(Helper.dates.toString(value)))
                value = this.state.until;
            this.setState({ until: value }, this.loadAssignments)
        }
        return (
            <FieldInstance label={this.props.context.translations["Field.Beleg.dbis"]}>
                <DatePicker {...props} />
            </FieldInstance>
        );
    }

    private renderGrid = () => {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.props.field.gridOptions}
                    id="flagAssignmentsGrid"
                    customButtons={this.buttons}
                    onClickCustomButton={this.handleCustomButtonClick}
                />
            </div>
        );
    }

    private handleCustomButtonClick = (id: string) => {
        switch (id) {
            case "addAssignments":
                const sheet = General.Sheet.Manager.createSheetWithUrl(`CreateMultipleAssignments/Index?flagId=${this.props.entity.Id}`);
                sheet.bind(SheetEventType.Close, this.loadAssignments)
                break;
        }
    }


    render() {
        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                {this.renderFromDatePicker()}
                {this.renderUntilDatePicker()}
                {this.renderGrid()}
            </div>
        );
    }
}

interface FlagAssignmentsGridProps extends BaseComponentProps {
    entity: FlagEntity;
    context: FlagContext;
    field: FlagResourceGridField;
}

interface FlagResourceGridField extends BaseField {
    gridOptions: kendo.ui.GridOptions;
}

interface FlagAssignmentsGridState {
    gridData: any[];
    from: Date;
    until: Date;
}